<template>
  <h4 class="text-center" style="color: #439539">Register An Account</h4>
  <div id="regStep1">
    <p class="text-center">
      Join today and get 100% first deposit match as a Free Bet. Visit our T&C's
      page for offer details.
    </p>
    <br />
    <form>
      <div class="mb-3" style="text-align: center">
        <input
          type="number"
          class="form-control"
          data-val="true"
          errorText="Invalid mobile number"
          pattern="^[1-9][0-9]{8}$|^0[0-9]{9}$"
          id="MobileNumber"
          name="MobileNumber"
          required="true"
          placeholder="Mobile Number"
          @keyup="validate"
        />
        <span class="error-text" />
      </div>
      <div class="mb-3" style="text-align: center">
        <input
          data-translate-set="ErrorMessages"
          data-translate-key="PasswordName"
          data-translate-type="placeholder"
          class="form-control passwordToggle valid"
          data-val="true"
          required="true"
          placeholder="Password"
          errorText="Invalid password. Please enter an alpha-numeric password containing 5-10 characters."
          pattern="^[a-zA-Z0-9\@\#\$\%\.\!\&amp;\+\-]{5,10}"
          maxlength="10"
          id="Password"
          name="Password"
          type="password"
          @keyup="validate"
        />
        <span class="error-text" />
      </div>
      <div class="mb-3" style="text-align: center">
        <input
          data-translate-set="ErrorMessages"
          data-translate-key="FirstnameName"
          data-translate-type="placeholder"
          type="text"
          class="form-control input-validation-error"
          data-val="true"
          errorText="Please enter valid first name with 2 or more characters"
          pattern="^[a-zA-Z-_ ]{2,}"
          id="FirstName"
          name="FirstName"
          required="true"
          title="Enter your first name/s exactly as it appears on your ID document."
          placeholder="First and Middle Name (As it appears on your ID)"
          @keyup="validate"
        />
        <span class="error-text" />
      </div>
      <div class="mb-3" style="text-align: center">
        <input
          type="text"
          class="form-control input-validation-error"
          data-val="true"
          errorText="Please enter valid surname with 2 or more characters"
          pattern="^[a-zA-Z-_ ]{2,}"
          id="LastName"
          name="LastName"
          required="true"
          title="Enter your surname exactly as it appears on your ID document."
          placeholder="Surname (As it appears on your ID)"
          @keyup="validate"
        />
        <span class="error-text" />
      </div>
      <div class="mb-3" style="text-align: center">
        <input
          data-translate-set="ErrorMessages"
          data-translate-key="EmailRequiredName"
          data-translate-type="placeholder"
          type="text"
          class="form-control email-input input-validation-error"
          data-val="true"
          errorText="Please enter a valid E-mail address"
          pattern="^[A-Za-z0-9\s*._%+-]+@[A-Za-z0-9\s*.-]+\.[A-Za-z\s*]{2,}$"
          id="Email"
          name="Email"
          required="false"
          placeholder="Email"
          @keyup="validate"
        />
        <span class="error-text" />
      </div>
    </form>
    <button class="form-btn-one d-block mx-auto" @click="validateStep1()">
      Next
    </button>
    <br />
    <p v-if="!this.isZeroRated" class="text-center">Already Have an Account?</p>
    <button
      v-if="!this.isZeroRated"
      data-bs-toggle="modal"
      data-bs-target="#loginModal"
      data-bs-dismiss="modal"
      class="form-btn-two d-block mx-auto"
    >
      Click here to log in
    </button>
  </div>

  <div id="regStep2" style="display: none">
    <form>
      <div class="mb-3" style="text-align: center">
        <label class="flex label" style="float: left">
          <span> Select ID Type </span>
        </label>
        <div class="mb-3">
          <select
            data-val=""
            data-val-required=""
            class="form-control"
            id="IDType"
            title=""
            name="IDType"
            @change="idTypeChange"
          >
            <option
              data-translate-set="SignUpDialog"
              data-translate-key="SouthAfricanID"
              value="South African ID"
            >
              South African ID
            </option>
            <option
              data-translate-set="SignUpDialog"
              data-translate-key="Passport"
              value="Passport"
            >
              Passport
            </option>
          </select>
          <span class="error-text" />
        </div>

        <div class="mb-3" style="text-align: center">
          <input
            type="text"
            class="form-control"
            errorText="Please Enter A Valid ID Or PassportNumber"
            pattern="^(?!\s*$).+"
            id="IDNumber"
            name="IDNumber"
            required="true"
            title=""
            placeholder="Please Enter ID Number"
            @keyup="validateID"
          />
          <span class="error-text" />
        </div>

        <div class="mb-3" style="text-align: center" id="date-of-birth">
          <label class="flex label" style="float: left">
            <span>Date Of Birth </span>
          </label>
          <br />
          <div class="mb-3" style="display: grid">
            <div class="date-of-birth" >
              <div class="col-custom">
                <select class="form-control" id="Day" name="Day">
                  <option value="" selected="selected">Day</option>
                  <option value="1">1</option>
                  <option value="2">2</option>
                  <option value="3">3</option>
                  <option value="4">4</option>
                  <option value="5">5</option>
                  <option value="6">6</option>
                  <option value="7">7</option>
                  <option value="8">8</option>
                  <option value="9">9</option>
                  <option value="10">10</option>
                  <option value="11">11</option>
                  <option value="12">12</option>
                  <option value="13">13</option>
                  <option value="14">14</option>
                  <option value="15">15</option>
                  <option value="16">16</option>
                  <option value="17">17</option>
                  <option value="18">18</option>
                  <option value="19">19</option>
                  <option value="20">20</option>
                  <option value="21">21</option>
                  <option value="22">22</option>
                  <option value="23">23</option>
                  <option value="24">24</option>
                  <option value="25">25</option>
                  <option value="26">26</option>
                  <option value="27">27</option>
                  <option value="28">28</option>
                  <option value="29">29</option>
                  <option value="30">30</option>
                  <option value="31">31</option>
                </select>
                <span></span>
              </div>
              <div class="col-custom">
                <select
                  class="form-control"
                  data-translate-set="DatePicker"
                  data-translate-type="select"
                  id="Month"
                  name="Month"
                  style="pointer-events: auto"
                >
                  <option
                    value=""
                    data-translate-key="Month"
                    selected="selected"
                  >
                    Month
                  </option>
                  <option value="1" data-translate-key="January">
                    January
                  </option>
                  <option value="2" data-translate-key="February">
                    February
                  </option>
                  <option value="3" data-translate-key="March">March</option>
                  <option value="4" data-translate-key="April">April</option>
                  <option value="5" data-translate-key="May">May</option>
                  <option value="6" data-translate-key="June">June</option>
                  <option value="7" data-translate-key="July">July</option>
                  <option value="8" data-translate-key="August">Aug</option>
                  <option value="9" data-translate-key="September">
                    September
                  </option>
                  <option value="10" data-translate-key="October">
                    October
                  </option>
                  <option value="11" data-translate-key="November">
                    November
                  </option>
                  <option value="12" data-translate-key="December">
                    December
                  </option>
                </select>
                <span></span>
              </div>
              <div class="col-custom">
                <select
                  class="form-control"
                  id="Year"
                  name="Year"
                  style="pointer-events: auto"
                >
                  <option
                    value=""
                    data-translate-key="Year"
                    selected="selected"
                  >
                    Year
                  </option>
                  <option value="2005">2005</option>
                  <option value="2004">2004</option>
                  <option value="2003">2003</option>
                  <option value="2002">2002</option>
                  <option value="2001">2001</option>
                  <option value="2000">2000</option>
                  <option value="1999">1999</option>
                  <option value="1998">1998</option>
                  <option value="1997">1997</option>
                  <option value="1996">1996</option>
                  <option value="1995">1995</option>
                  <option value="1994">1994</option>
                  <option value="1993">1993</option>
                  <option value="1992">1992</option>
                  <option value="1991">1991</option>
                  <option value="1990">1990</option>
                  <option value="1989">1989</option>
                  <option value="1988">1988</option>
                  <option value="1987">1987</option>
                  <option value="1986">1986</option>
                  <option value="1985">1985</option>
                  <option value="1984">1984</option>
                  <option value="1983">1983</option>
                  <option value="1982">1982</option>
                  <option value="1981">1981</option>
                  <option value="1980">1980</option>
                  <option value="1979">1979</option>
                  <option value="1978">1978</option>
                  <option value="1977">1977</option>
                  <option value="1976">1976</option>
                  <option value="1975">1975</option>
                  <option value="1974">1974</option>
                  <option value="1973">1973</option>
                  <option value="1972">1972</option>
                  <option value="1971">1971</option>
                  <option value="1970">1970</option>
                  <option value="1969">1969</option>
                  <option value="1968">1968</option>
                  <option value="1967">1967</option>
                  <option value="1966">1966</option>
                  <option value="1965">1965</option>
                  <option value="1964">1964</option>
                  <option value="1963">1963</option>
                  <option value="1962">1962</option>
                  <option value="1961">1961</option>
                  <option value="1960">1960</option>
                  <option value="1959">1959</option>
                  <option value="1958">1958</option>
                  <option value="1957">1957</option>
                  <option value="1956">1956</option>
                  <option value="1955">1955</option>
                  <option value="1954">1954</option>
                  <option value="1953">1953</option>
                  <option value="1952">1952</option>
                  <option value="1951">1951</option>
                  <option value="1950">1950</option>
                  <option value="1949">1949</option>
                  <option value="1948">1948</option>
                  <option value="1947">1947</option>
                  <option value="1946">1946</option>
                  <option value="1945">1945</option>
                  <option value="1944">1944</option>
                  <option value="1943">1943</option>
                  <option value="1942">1942</option>
                  <option value="1941">1941</option>
                  <option value="1940">1940</option>
                  <option value="1939">1939</option>
                  <option value="1938">1938</option>
                  <option value="1937">1937</option>
                  <option value="1936">1936</option>
                  <option value="1935">1935</option>
                  <option value="1934">1934</option>
                  <option value="1933">1933</option>
                  <option value="1932">1932</option>
                  <option value="1931">1931</option>
                  <option value="1930">1930</option>
                  <option value="1929">1929</option>
                  <option value="1928">1928</option>
                  <option value="1927">1927</option>
                  <option value="1926">1926</option>
                  <option value="1925">1925</option>
                  <option value="1924">1924</option>
                  <option value="1923">1923</option>
                  <option value="1922">1922</option>
                  <option value="1921">1921</option>
                  <option value="1920">1920</option>
                  <option value="1919">1919</option>
                  <option value="1918">1918</option>
                  <option value="1917">1917</option>
                  <option value="1916">1916</option>
                  <option value="1915">1915</option>
                  <option value="1914">1914</option>
                  <option value="1913">1913</option>
                </select>
              </div>
            </div>
          </div>
          <span class="error-text" />
        </div>
      </div>

      <div class="mb-3" style="text-align: center">
        <label class="flex label" style="float: left">
          <span>Source of funds for betting transactions</span>
        </label>
        <select
          class="form-control"
          id="SourceOfFunds"
          title=""
          name="SourceOfFunds"
        >
          <option
            value="6e33fb24-5483-4388-9cd9-b5fbabba5bc5"
            regexpression=""
            placeholder-content=""
          >
            Salary
          </option>
          <option
            data-translate-set="SignUpDialog"
            data-translate-key="Wages"
            value="ac57c48d-5c09-4980-8425-9d745f111adb"
            regexpression=""
            placeholder-content=""
          >
            Wages
          </option>
          <option
            data-translate-set="SignUpDialog"
            data-translate-key="SelfEmployed"
            value="9d3a3d72-55d4-46e8-b298-76b3400f982f"
            regexpression=""
            placeholder-content=""
          >
            Self Employed
          </option>
          <option
            value="6c6952ea-f2d2-4606-ba84-3d31e3c8ea00"
            regexpression=""
            placeholder-content=""
          >
            Inheritance
          </option>
          <option
            value="630eb85d-522a-420a-91f5-39250d8a0749"
            regexpression=""
            placeholder-content=""
          >
            Savings
          </option>
          <option
            value="ddda97e0-e92d-4a80-b098-5166319dd731"
            regexpression=""
            placeholder-content=""
          >
            Investment Income
          </option>
          <option
            value="3b9288a9-6b2f-4859-9157-8ca6edde13d6"
            regexpression=""
            placeholder-content=""
          >
            Rental Income
          </option>
          <option
            value="8765b4a1-02e8-49fc-ad80-5790559fac7e"
            regexpression=""
            placeholder-content=""
          >
            Retirement Income
          </option>
          <option
            value="73fd9908-74a7-4887-998e-c3f5c2379eeb"
            regexpression=""
            placeholder-content=""
          >
            Government Assistance
          </option>
        </select>
      </div>
      <div class="mb-3" style="text-align: center">
        <label class="flex label" style="float: left">
          <span>Select Your Welcome Offer</span>
        </label>
        <br />
        <div style="text-align: left; display: grid; margin-left: 10px">
          <div>
            <input
              type="radio"
              class="radio-size styled"
              id="IsSportWelcomeOfferSelected"
              name="IsSportWelcomeOfferSelected"
              value="Sport Welcome Offer"
              style="height: 20px !important; width: 15px !important"
              checked="checked"
            />
            <label
              class="label-position label"
              style="text-indent: 10px; vertical-align: super"
              for="IsSportWelcomeOfferSelected"
            >
              Sport Welcome Offer
            </label>
          </div>
          <div>
            <input
              type="radio"
              class="radio-size styled"
              data-val=""
              data-val-required=""
              id="IsNoWelcomeOfferSelected"
              name="IsSportWelcomeOfferSelected"
              value="No, Thanks"
              style="height: 20px !important; width: 15px !important"
            />
            <label
              data-translate-set="SignUpDialog"
              data-translate-key="NoThanksOption"
              class="label-position label"
              style="text-indent: 10px; vertical-align: super"
              for="IsNoWelcomeOfferSelected"
            >
              No, Thanks
            </label>
          </div>
        </div>
      </div>

      <div class="mb-3" style="text-align: center">
        <div class="checkbox">
          <label class="label">
            <input
              class=""
              id="AgreeToAll"
              name="AgreeToAll"
              style="height: auto !important"
              type="checkbox"
              value="true"
              @change="agreeToAll"
            />
            <span
              class="text--bold"
              data-translate-set="SignUpDialog"
              data-translate-key="AgreeToAll"
            >
              Agree to All</span
            >
          </label>
        </div>
      </div>
      <div class="mb-3" style="text-align: center">
        <div class="checkbox">
          <label class="agreeToAll-list-item">
            <input
              class="toggleAgreeToAll valid"
              id="StopCommunication"
              name="StopCommunication"
              style="height: auto !important"
              type="checkbox"
              value="true"
              aria-invalid="false"
            />
            <span style="padding-left: 10px">Receive game-changing promotions and marketing updates</span
            >
          </label>
        </div>
      </div>

      <div class="checkbox">
        <label class="agreeToAll-list-item">
          <input
            class="toggleAgreeToAll valid"
            id="ConfirmAge"
            name="ConfirmAge"
            required="required"
            style=""
            @change="confirmAge"
            type="checkbox"
            value="true"
          />
          <span style="padding-left: 10px"
            >I am over 18 years of age and I accept Betway’s Terms And
            Conditions and Privacy Policy</span
          >
        </label>
        <span class="error-text" style="width: 100%; position: absolute" />
      </div>
    </form>
    <div
      style="width: 100%; text-align: center; padding: 10px; margin-top: 20px"
    >
      <button class="form-btn-two" style="margin-right: 2px" @click="back()">
        Back
      </button>
      <button class="form-btn-one" style="margin-left: 2px" @click="register()">
        Register
      </button>
      <br />
      <span id="regError" v-if="showGeneralError" class="error-text">
        {{ GeneralErrorText }}
      </span>
    </div>
  </div>
  <div id="regStep3" style="display: none; text-align: center">
    <div class="row ty-row">
      <div class="col-xs-12">
        <h3>Thank you for Registering on</h3>
      </div>
      <h3>Betway</h3>
      <div class="col-xs-12 ty-acc-no">
        <span
          ><b>Do not share your account information with others.&nbsp;</b>
          <div><b>Your account number is</b></div></span
        ><br />
        <span
          ><b>{{ accountNumber }}</b></span
        >
        <br>
        <b>Continue to the Betway site</b>
         <br />
         <a :href="getHost">Click here</a>
         <p>You are leaving datafree when navigating to this website</p>
      </div>
    </div>
  </div>
</template>
  <script>
import axios from "axios";
import { StorageUtil } from "../utils/storageUtils";
export default {
  computed: {
    getHost(){
      return this.host+this.domain
    }
  },
  data() {
    return {
      showGeneralError: false,
      GeneralErrorText: "",
      isZeroRated: false,
      accountNumber: "",
      host:"https://"+"www.",
      domain: "betway"+".co.za"
    };
  },
  mounted() {
    const storage = new StorageUtil();
    if (storage.getSessionStorage("datafree")) {
      this.isZeroRated = true;
    }
  },
  methods: {
    validateStep1() {
      const inputs = document.querySelectorAll("#regStep1 input");
      let valid = true;
      inputs.forEach((input) => {
        const result = this.validate(null, input);
        if (!result) {
          valid = false;
        }
      });

      if (valid) {
        document.getElementById("regStep1").style.display = "none";
        document.getElementById("regStep2").style.display = "block";
      }
    },
    back() {
      document.getElementById("regStep1").style.display = "block";
      document.getElementById("regStep2").style.display = "none";
    },
    validate(e, input) {
      const field = e ? e.target : input;
      if (field.pattern && new RegExp(field.pattern).test(field.value)) {
        field.parentNode.className = "mb-3 valid";
        field.parentNode.querySelector(".error-text").innerHTML = "";
      } else if (field.required && field.value.trim() === "") {
        field.parentNode.className = "mb-3 required";
        field.parentNode.querySelector(".error-text").innerHTML =
          "This field is required.";
        return false;
      } else {
        field.parentNode.className = " mb-3 invalid";
        field.parentNode.querySelector(".error-text").innerHTML =
          field.getAttribute("errorText");
        return false;
      }
      return true;
    },
    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },

    idTypeChange(e) {
      if (e.target.value === "South African ID") {
        document
          .getElementById("IDNumber")
          .setAttribute("placeholder", "Please Enter ID Number");
      } else {
        document
          .getElementById("IDNumber")
          .setAttribute("placeholder", "Please Enter Passport Number");
      }
    },
    validateID(e, input) {
      const field = e ? e.target : input;
      document
        .getElementsByClassName("date-of-birth")[0]
        .parentNode.classList.remove("disable");
      if (field.required && field.value.trim() === "") {
        field.parentNode.className = "mb-3 required";
        field.parentNode.querySelector(".error-text").innerHTML =
          "This field is required.";
        return false;
      } else if (
        document.getElementById("IDType").value === "South African ID"
      ) {
        var idNumber = field.value;
        var correct = true;
        if (idNumber.length != 13 || !this.isNumber(idNumber)) {
          correct = false;
        }

        var tempDate = new window.Date(
          idNumber.substring(0, 2),
          idNumber.substring(2, 4) - 1,
          idNumber.substring(4, 6)
        );

        var id_date = tempDate.getDate();
        var id_month = tempDate.getMonth();
        var id_year = tempDate.getFullYear();

        if (
          !(
            tempDate.getYear() == idNumber.substring(0, 2) &&
            id_month == idNumber.substring(2, 4) - 1 &&
            id_date == idNumber.substring(4, 6)
          )
        ) {
          correct = false;
        }

        var tempTotal = 0;
        var checkSum = 0;
        var multiplier = 1;
        for (var i = 0; i < 13; ++i) {
          tempTotal = parseInt(idNumber.charAt(i)) * multiplier;
          if (tempTotal > 9) {
            tempTotal =
              parseInt(tempTotal.toString().charAt(0)) +
              parseInt(tempTotal.toString().charAt(1));
          }
          checkSum = checkSum + tempTotal;
          multiplier = multiplier % 2 == 0 ? 1 : 2;
        }
        if (checkSum % 10 != 0) {
          correct = false;
        }
        if (correct) {
          field.parentNode.className = "mb-3 valid";
          field.parentNode.querySelector(".error-text").innerHTML = "";
          document
            .getElementsByClassName("date-of-birth")[0]
            .parentNode.classList.add("disable");
          document.getElementById("Year").value = id_year;
          document.getElementById("Month").value = id_month + 1;
          document.getElementById("Day").value = id_date;
          return true;
        } else {
          field.parentNode.className = " mb-3 invalid";
          field.parentNode.querySelector(".error-text").innerHTML =
            field.getAttribute("errorText");
          return false;
        }
      } else if (
        document.getElementById("IDType").value === "Passport" &&
        field.pattern &&
        new RegExp(field.pattern).test(field.value)
      ) {
        field.parentNode.className = "mb-3 valid";
        field.parentNode.querySelector(".error-text").innerHTML = "";
        return true;
      } else {
        field.parentNode.className = " mb-3 invalid";
        field.parentNode.querySelector(".error-text").innerHTML =
          field.getAttribute("errorText");
        return false;
      }
    },
    agreeToAll(e) {
      document.getElementById("ConfirmAge").checked = e.target.checked;
      document.getElementById("StopCommunication").checked = e.target.checked;
    },
    confirmAge(e) {
      if (e.target.checked) {
        document
          .getElementById("ConfirmAge")
          .parentNode.parentNode.querySelector(".error-text").innerHTML = "";
      } else {
        document.getElementById("ConfirmAge").parentNode.parentNode.className =
          "mb-3 required";
        document
          .getElementById("ConfirmAge")
          .parentNode.parentNode.querySelector(".error-text").innerHTML =
          "This field is required.";
      }
    },
    isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    prepareDateOfBirth({ year, month, day }) {
      if (!(year && month && day)) return undefined;
      return `${year}-${month < 10 ? "0" : ""}${month}-${
        day < 10 ? "0" : ""
      }${day}T00:00:00.000Z`;
    },
    validateDateOfBirth(d, m, y) {
        return y > 1900 && m > 0 && m <= 12 && d > 0 && d <= this.daysInMonth(m, y);
    },
    daysInMonth(m, y) {
        var ml = parseInt(m);
        var yl = parseInt(y);
        switch (ml) {
            case 2:
                return (yl % 4 == 0 && yl % 100) || yl % 400 == 0 ? 29 : 28;
            case 4: case 6: case 9: case 11:
                return 30;
            default:
                return 31
        }
    },
    async register() {
      this.showGeneralError = false;
      let isValid = true;

      if (!this.validateID(null, document.getElementById("IDNumber"))) {
        isValid = false;
      }
      
      if(this.validateDateOfBirth(document.getElementById("Day").value, document.getElementById("Month").value, document.getElementById("Year").value,) !== true){

        isValid = false;
        document
          .getElementById("date-of-birth").querySelector(".error-text").innerHTML =
          "Please enter a valid date of birth.";
      }else{

        document
          .getElementById("date-of-birth").querySelector(".error-text").innerHTML = "";
      }

      if (!document.getElementById("ConfirmAge").checked) {
        isValid = false;
        document.getElementById("ConfirmAge").parentNode.parentNode.className =
          "mb-3 required";
        document
          .getElementById("ConfirmAge")
          .parentNode.parentNode.querySelector(".error-text").innerHTML =
          "This field is required.";
      } else {
        document
          .getElementById("ConfirmAge")
          .parentNode.parentNode.querySelector(".error-text").innerHTML = "";
      }

      if (isValid) {
        const storage = new StorageUtil();
        let month = document.getElementById("Month").value;

        if (month < 10) {
          month = +"0" + month;
        }

        let regRequest = {
          ConfirmAge: true,
          ConfirmTerms: true,
          Country: "ZA",
          DateOfBirth: this.prepareDateOfBirth({
            year: document.getElementById("Year").value,
            month: document.getElementById("Month").value,
            day: document.getElementById("Day").value,
          }),
          DialingCode: "+27",
          Email: document.getElementById("Email").value,
          FirstName: document.getElementById("FirstName").value,
          IDNumber: document.getElementById("IDNumber").value,
          Language: "en",
          LastName: document.getElementById("LastName").value,
          MobileNumber: document.getElementById("MobileNumber").value,
          Password: document.getElementById("Password").value,
          IDType: document.getElementById("IDType").value,
          ReceivePromotionInfo:
            document.getElementById("StopCommunication").checked,
          UnsubscribeCorrespondence:
            !document.getElementById("StopCommunication").checked,
          BrandLanguageId: "3b0f6e0b-33b9-492e-8ea9-edfa9446d6ba",
          StopCommunication:
            !document.getElementById("StopCommunication").checked,
          BrandId: "BD66EBE1-080B-4455-9094-BF0464D4ADBF",
          IsMobile: true,
          BannerTag: storage.getCookie("BTAGCOOKIE"),
          MasterToken: storage.getCookie("MT"),
          SessionToken: storage.getCookie("ST"),
          OriginalQueryString: storage.getCookie("OriginalQueryString"),
          SourceOfFunds: document.getElementById("SourceOfFunds").value,
          WelcomeOffer: document.querySelector(
            'input[name="IsSportWelcomeOfferSelected"]:checked'
          ).value,
        };

        const options = {
          headers: {
            "x-vuvuzelaregion": "ZA",
          },
        };
        document.getElementById("loading").style.display = "block";
        let data = await axios
          .post(
            "https://api-betwayafrica-com-betwayreg.datafree.io/api/v1/Account/Vuvuzela/Register",
            regRequest,
            options
          )
          .catch((error) => {
            if (error.response) {
              document.getElementById("loading").style.display = "none";
              this.GeneralErrorText = error.response.data.errorMessage;
              this.showGeneralError = true;
            }
          });
        if (data.data && data.data.AccountId) {
          this.addMarketingSession(data.data.AccountId)
          if (dataLayer) {
                    dataLayer.push({
                      'event': 'RegistrationCompletedEvent',
                      'player_id':data.data.AccountId,
                      'banner_tag': storage.getCookie("BTAGCOOKIE"),
                      'session_token': storage.getCookie("ST"),
                      'master_token': storage.getCookie("MT"),
                    });
              }
          if (this.isZeroRated) {
            this.accountNumber = regRequest.MobileNumber;
            document.getElementById("loading").style.display = "none";
            document.getElementById("regStep1").style.display = "none";
            document.getElementById("regStep2").style.display = "none";
            document.getElementById("regStep3").style.display = "block";
          } else {
          var url = "https://www-betway-co-za-betwayreg.datafree.io/appsynapse/auth/users/authenticate?nogeoredirect=1";
            fetch(url, {
              method: "POST",
              body: JSON.stringify({
                username:regRequest.MobileNumber,
                password:regRequest.Password,
                countryCode:"ZA"
            }),
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
            })
              .then((response) => response.text())
              .then((data) => {
                console.log(JSON.parse(data));
                data = JSON.parse(data);
                if (data.errorCode) {
                  this.GeneralErrorText = data.errorMessage;
                  this.showGeneralError = true;
                  document.getElementById("loading").style.display = "none";
                } else {
                  const storage = new StorageUtil();
                  storage.setWildCardCookie("betway-auth", data.access_token, 30);
                  window.location.href = "https://new.betway.co.za";
                }
              });
          }
        }
      }
    },
    addMarketingSession(accountId){
    const storage = new StorageUtil();
    var request = {
            platformID: 1,
            regionID: 1,
            vendorAccountID: accountId,
            dataFree: false,
            bannerTag:storage.getCookie("BTAGCOOKIE"),
            queryParamString: '',
            ipAddress: '',
            countryCode: 'za',
            userAgent: navigator.userAgent,
            isMobile: false,
            isTable: false,
            deviceOsName: '',
            deviceBrowserName: '',
            deviceBrowserVersion: '',
            sessionTrackingToken: window.sessionStorage.getItem('sessionTrackingTokenEncoded')
        }

        axios
          .post(
            "https://api-betwayafrica-com-betwayreg.datafree.io/api/v1/Marketing/AddMarketingSession",
            request
          )
  }
  },
};
</script>
  
 <style>
.error-text {
  color: red;
  margin: 2px 0 0;
  font-size: 12px;
  clear: both;
  text-align: center;
}
.date-of-birth select {
  float: left;
  width: 32%;
  margin: 0 2% 0 0;
  background-image: none;
  background: #fff;
  border-color: #ccc;
  color: #999;
  padding: 0 0 0 6px;
  display: inline-block;
  position: relative;
  width: 30%;
  height: 40px !important;
}
.disable .date-of-birth select {
  pointer-events: none !important;
}
.label {
  font-weight: 700;
}
.checkbox {
  text-align: left;
}
</style>
  